

<template>
  <div class="download">
    <div class="breadcrumb text-no">
      <span class="TitBtn" @click="out()">
        <i class="el-icon-arrow-left"></i> 返回</span
      >
      <span class="tipName"
        >月结设置 / 账单模板 / <span class="currentTip">{{item.templateName}}</span></span
      >
    </div>
    <div class="cen">
      <!-- 中间内容 -->
      <div class="content">
        <signboard signboardName="模板名称"></signboard>
        <div  class='head df'>
        <div class="serch1">
          模版名称：<el-input
           :disabled='item.isCommon != 0'
            size="mini"
            placeholder="请输入内容"
            v-model="item.templateName"
            clearable
          >
          </el-input>
          </div>
          <div class="accomplish">
            <el-button  type="primary" v-if='item.isCommon == 0' @click="submit" size="small">完成</el-button>
          </div>
          <!-- <div @click="submit">完成</div> -->
        </div>
        <signboard signboardName="零担"></signboard>
        <div class="checkBox1">
          <div class="all">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange0"
              :disabled='item.isCommon != 0'
              >全选</el-checkbox
            >
          </div>
          <div class="son">
            <el-checkbox-group
              v-model="checkedCities0"
              @change="handleCheckedCitiesChange0"
            >
              <el-checkbox :disabled='item.isCommon != 0' v-for="city in cities0" :label="city" :key="city">{{
                city
              }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <signboard signboardName="快递"></signboard>
        <div class="checkBox1">
          <div class="all">
            <el-checkbox
              :indeterminate="isIndeterminate1"
              v-model="checkAll1"
              :disabled='item.isCommon != 0'
              @change="handleCheckAllChange1"
              >全选</el-checkbox
            >
          </div>
          <div class="son">
            <el-checkbox-group
              v-model="checkedCities1"
              @change="handleCheckedCitiesChange1"
            >
              <el-checkbox :disabled='item.isCommon != 0' v-for="city in cities1" :label="city" :key="city">{{
                city
              }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <signboard signboardName="仓储"></signboard>
        <div class="checkBox1">
          <div class="all">
            <el-checkbox
              :indeterminate="isIndeterminate2"
              v-model="checkAll2"
              @change="handleCheckAllChange2"
              :disabled='item.isCommon != 0'
              >全选</el-checkbox
            >
          </div>
          <div class="son">
            <el-checkbox-group
              v-model="checkedCities2"
              @change="handleCheckedCitiesChange2"
            >
              <el-checkbox :disabled='item.isCommon != 0' v-for="city in cities2" :label="city" :key="city">{{
                city
              }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <signboard signboardName="整车"></signboard>
        <div class="checkBox1">
          <div class="all">
            <el-checkbox
              :indeterminate="isIndeterminate3"
              v-model="checkAll3"
              @change="handleCheckAllChange3"
              :disabled='item.isCommon != 0'
              >全选</el-checkbox
            >
          </div>
          <div class="son">
            <el-checkbox-group
              v-model="checkedCities3"
              @change="handleCheckedCitiesChange3"
            >
              <el-checkbox :disabled='item.isCommon != 0' v-for="city in cities3" :label="city" :key="city">{{
                city
              }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import signboard from "@/components/signboard";
import { paths } from "../../../utils/pathNew.js";
// import API from '@/api/setTing'
// const api = new API
import API from "@/api/setTing";
const api = new API();
export default {
  components: { signboard },
  data() {
    return {
      input: "模板1",
      checkAll: false,
      checkedCities0: [],
      cities0: [],
      isIndeterminate: true,

      item: {},
      listAll: [],

      checkedCities1: [],
      cities1: [],
      checkAll1: false,
      isIndeterminate1: true,

      checkedCities2: [],
      cities2: [],
      checkAll2: false,
      isIndeterminate2: true,

      checkedCities3: [],
      cities3: [],
      checkAll3: false,
      isIndeterminate3: true,
    };
  },
  computed: {},
  watch: {},
  methods: {
    out() {
      this.$router.go(-1);
      this.$store.commit("setTingIndex", 1);
    },
    handleCheckAllChange0(val) {
      this.checkedCities0 = val ? this.cities0 : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange0(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities0.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities0.length;
      console.log(2, value);
    },

    handleCheckAllChange1(val) {
      this.checkedCities1 = val ? this.cities1 : [];
      this.isIndeterminate1 = false;
    },
    handleCheckedCitiesChange1(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities1.length;
      this.isIndeterminate1 =
        checkedCount > 0 && checkedCount < this.cities1.length;
    },

    handleCheckAllChange2(val) {
      this.checkedCities2 = val ? this.cities2 : [];
      this.isIndeterminate2 = false;
    },
    handleCheckedCitiesChange2(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities2.length;
      this.isIndeterminate2 =
        checkedCount > 0 && checkedCount < this.cities2.length;
    },

    handleCheckAllChange3(val) {
      this.checkedCities3 = val ? this.cities3 : [];
      this.isIndeterminate3 = false;
    },
    handleCheckedCitiesChange3(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities3.length;
      this.isIndeterminate3 =
        checkedCount > 0 && checkedCount < this.cities3.length;
    },

    async submit() {
      this.listAll.map((i, j) => {
        i.fieldDOList.map((n) => {
          if (j == 3) {
            if (this.checkedCities3.includes(n.fieldValue)) {
              n.disable = "1";
            } else {
              n.disable = "0";
            }
          } else if (j == 2) {
            if (this.checkedCities2.includes(n.fieldValue)) {
              n.disable = "1";
            } else {
              n.disable = "0";
            }
          } else if (j == 1) {
            if (this.checkedCities1.includes(n.fieldValue)) {
              n.disable = "1";
            } else {
              n.disable = "0";
            }
          } else if (j == 0) {
            if (this.checkedCities0.includes(n.fieldValue)) {
              n.disable = "1";
            } else {
              n.disable = "0";
            }
          }
        });
      });
      this.item.attribute = JSON.stringify(this.listAll)
      console.log(this.item);
      let parme = {
        ...this.item
      }
      const res = await api.updateTemplate(parme)
      if(res.success){
        this.$message({
          message: res.errorMessage,
          type: "success",
        });
      }
      this.out()
    },
  },
  mounted() {},
  created() {
    // 设置 默认值为月结信息 Tab
    let url = window.location.hash;
    this.$store.commit("urlIndex", paths(url));
    let setTingItem = sessionStorage.getItem("setTingItem");
    if(setTingItem == null){
      setTingItem = localStorage.getItem("setTingItem");
    }
    this.item = JSON.parse(setTingItem);
    this.listAll = JSON.parse(this.item.attribute);
    console.log(JSON.parse(sessionStorage.getItem("setTingItem")));
    this.listAll.map((i, j) => {
      i.fieldDOList.map((k) => {
        if (j == 0) {
          this.cities0.push(k.fieldValue);
          if (k.disable == "1") {
            this.checkedCities0.push(k.fieldValue);
          }
        }else if (j == 1) {
          this.cities1.push(k.fieldValue);
          if (k.disable == "1") {
            this.checkedCities1.push(k.fieldValue);
          }
        } else if (j == 2) {
          this.cities2.push(k.fieldValue);
          if (k.disable == "1") {
            this.checkedCities2.push(k.fieldValue);
          }
        } else if (j == 3) {
          this.cities3.push(k.fieldValue);
          if (k.disable == "1") {
            this.checkedCities3.push(k.fieldValue);
          }
        }
      });
    });
    },
};
</script>

<style lang='less' scoped>
.download {
  display: flex;
  height: 100%;
  flex: 1;
  overflow: auto;
  flex-direction: column;
  background-color: #f7f7f8ff;
  font-size: 14px;
  // text-align: right;
  .head {
    width: 100%;
    position: relative;
  }
   .accomplish{
     position: absolute;
     right: 100px;
   }
  .breadcrumb {
    text-align: left;
    height: 44px;
    margin-bottom: 5px;
    background: #fff;
    border: 1px solid #ececec;
    padding: 6px 24px;
    font-size: 14px;
    .TitBtn {
      display: inline-block;
      text-align: center;
      width: 76px;
      height: 32px;
      line-height: 32px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #afb1b7;
      padding-right: 10px;
      color: rgba(0, 0, 0, 0.6);
      cursor: pointer;
      margin-right: 20px;
    }
    .tipName {
      color: rgba(0, 0, 0, 0.4);
      .currentTip {
        color: #000000cc;
      }
    }
  }
  .cen {
    margin: 24px;
    display: flex;
    overflow: auto;
    background-color: #fff;
  }

  .content {
    width: 100%;
    height: 100%;
    text-align: left;
    .serch1 {
      width: 360px;
      display: flex;
      padding-left: 24px;
      align-items: center;
      .el-input {
        flex: 1;
      }
    }
    .checkBox1 {
      padding-left: 24px;
      display: flex;
      margin-bottom: 16px;
      position: relative;
      .all {
        width: 154px;
        height: 118px;
        background: #fafafa;
        border-radius: 4px;
        margin-right: 20px;
        position: absolute;
        top: 50%;
        transform: translate(0%, -50%);
        // ======================这里暂时隐藏设置全选，需要再放开=======================================================================================
        display: none;
        .el-checkbox {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .son {
        margin: 32px ;
        // ======================这里暂时隐藏设置全选，需要再放开=======================================================================================
        // margin-left: 170px;
        flex: 1;
        display: flex;
        align-items: center;
        .el-checkbox {
          width: 148px;
          margin: 0 10px 8px 0;
        }
      }
    }
  }
}
</style>